export type TenantViewMode = 'simple' | 'expert';

export const DEFAULT_TENANT_VIEW_MODE: TenantViewMode = 'simple';
